import { useLogoutMutation } from "@/services/authApi";
import { socketManager } from "@/services/websocket/socket-manager";
import { clearAuthTokens } from "@/utils/auth";
import { LOGOUT_USER_ACTION } from "@/utils/enums/auth.enums";
import { useDispatch } from "react-redux";

// Hook to handle user logout, clearing tokens from cookies and resetting redux store
export const useLogout = () => {
  const dispatch = useDispatch();
  const [logout] = useLogoutMutation();

  const logoutUser = async () => {
    await logout("").unwrap();
    clearAuthTokens();
    dispatch({ type: LOGOUT_USER_ACTION.NAME });
    socketManager.disconnectAll();
  };

  return { logoutUser };
};
